(function () {
  const root = document.getElementById("megaska-bag-root");
  if (!root) return;

  const MEGASKA_FALLBACK_API_BASE = "/apps/megaska/api";
const MEGASKA_PINCODE_ENDPOINT = "/apps/megaska/api/delhivery/pincode";

  const CHECKOUT_RESUME_KEY = "megaska_bag_resume_checkout";

  const state = {
    pageStatus: "loading",
    cart: null,
    customer: {
      sessionActive: false,
      profile: null,
      dashboard: null,
    },
    wallet: {
      visible: true,
      balance: 0,
      currency: "INR",
      pendingRefund: 0,
      status: "loading", // loading | login_required | available | unavailable
      message: null,
    },
    ui: {
      busyLineKey: null,
      busyAction: null,
      errorMessage: null,
      checkoutBusy: false,
    },
  };

  function formatMoneyFromMinor(amountMinor, currency) {
    const amount = Number(amountMinor || 0) / 100;
    try {
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: currency || "INR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    } catch (_error) {
      return `₹${amount.toFixed(2)}`;
    }
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function parseBagUpsellConfig() {
    const node = document.getElementById("megaska-bag-upsell-config");
    if (!node) return null;

    try {
      const parsed = JSON.parse(node.textContent || "{}");
      return parsed && typeof parsed === "object" ? parsed : null;
    } catch (_error) {
      return null;
    }
  }

  function normalizeText(value) {
    return String(value || "").trim().toLowerCase();
  }

  function cartContainsUpsellProduct(productId) {
    const items = Array.isArray(state.cart?.items) ? state.cart.items : [];
    return items.some((item) => Number(item.product_id) === Number(productId));
  }

  function cartMatchesUpsellTrigger(config) {
    const items = Array.isArray(state.cart?.items) ? state.cart.items : [];
    if (!items.length) return false;

    const triggerMode = String(config?.triggerMode || "keyword").trim();
    if (triggerMode === "always") return true;

    if (triggerMode === "tag") {
      const wantedTag = normalizeText(config?.triggerTag);
      if (!wantedTag) return false;

      return items.some((item) => {
        const tags = Array.isArray(item.product_tags)
          ? item.product_tags
          : String(item.product_tags || "")
              .split(",")
              .map((tag) => tag.trim())
              .filter(Boolean);

        return tags.some((tag) => normalizeText(tag) === wantedTag);
      });
    }

    const keyword = normalizeText(config?.triggerKeyword);
    if (!keyword) return false;

    return items.some((item) => {
      const haystack = [
        item?.product_title,
        item?.title,
        item?.variant_title,
        item?.product_type,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return haystack.includes(keyword);
    });
  }

  function getUpsellDisplayPrice(config) {
    if (config?.offerPriceText) return String(config.offerPriceText).trim();
    const amount = Number(config?.product?.price || 0);
    return formatMoneyFromMinor(amount, state.cart?.currency || "INR");
  }

  function getUpsellComparePrice(config) {
    if (config?.comparePriceText) return String(config.comparePriceText).trim();

    const compareAt = Number(config?.product?.compareAtPrice || 0);
    if (compareAt > 0) {
      return formatMoneyFromMinor(compareAt, state.cart?.currency || "INR");
    }

    return "";
  }

  function shouldRenderUpsell() {
    const config = parseBagUpsellConfig();
    if (!config || !config.enabled || !config.product || !config.product.variantId) return false;
    if (!state.cart || !Array.isArray(state.cart.items) || !state.cart.items.length) return false;

    if (config.hideIfAlreadyInBag && cartContainsUpsellProduct(config.product.id)) {
      return false;
    }

    return cartMatchesUpsellTrigger(config);
  }

  function renderUpsellSection() {
    const config = parseBagUpsellConfig();
    if (!config || !shouldRenderUpsell()) return "";

    const product = config.product || {};
    const heading = config.heading || "Complete your swim set";
    const text = config.text || "";
    const badge = config.badge || "";
    const ctaLabel = config.ctaLabel || "Add offer";
    const offerPrice = getUpsellDisplayPrice(config);
    const comparePrice = getUpsellComparePrice(config);

    return `
      <section id="bag-upsell-section" class="megaska-bag-card megaska-bag-upsell">
        <div class="megaska-bag-upsell__media">
          ${
            product.featuredImage
              ? `<img
                  src="${escapeHtml(product.featuredImage)}"
                  alt="${escapeHtml(product.title || heading)}"
                  class="megaska-bag-upsell__image"
                  loading="lazy"
                >`
              : `<div class="megaska-bag-upsell__image-placeholder"></div>`
          }
        </div>

        <div class="megaska-bag-upsell__content">
          ${
            badge
              ? `<div class="megaska-bag-upsell__badge">${escapeHtml(badge)}</div>`
              : ""
          }

          <h3 class="megaska-bag-upsell__title">${escapeHtml(heading)}</h3>

          <p class="megaska-bag-upsell__product">${escapeHtml(product.title || "")}</p>

          ${
            text
              ? `<p class="megaska-bag-upsell__text">${escapeHtml(text)}</p>`
              : ""
          }

          <div class="megaska-bag-upsell__price-row">
            <strong class="megaska-bag-upsell__price">${escapeHtml(offerPrice)}</strong>
            ${
              comparePrice
                ? `<span class="megaska-bag-upsell__compare">${escapeHtml(comparePrice)}</span>`
                : ""
            }
          </div>

          <div class="megaska-bag-upsell__actions">
            <button
              class="megaska-bag-btn megaska-bag-btn--primary"
              type="button"
              data-bag-action="add-upsell"
            >
              ${escapeHtml(ctaLabel)}
            </button>
          </div>
        </div>
      </section>
    `;
  }

  async function addUpsellVariantToCart() {
    const config = parseBagUpsellConfig();
    const variantId = Number(config?.product?.variantId || 0);

    if (!variantId) {
      throw new Error("Upsell product is not configured correctly.");
    }

    const response = await fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    });

    if (!response.ok) {
      throw new Error(`Unable to add offer (${response.status})`);
    }

    return response.json();
  }

  function getMegaskaApiBase() {
    const configuredBase = String(window?.MegaskaAuth?.API_BASE || "")
      .trim()
      .replace(/\/$/, "");
    return configuredBase || MEGASKA_FALLBACK_API_BASE;
  }

function normalizeShopDomain(input) {
  return String(input || "")
    .trim()
    .replace(/^https?:\/\//, "")
    .replace(/\/$/, "")
    .toLowerCase();
}

function isMyShopifyDomain(value) {
  return /\.myshopify\.com$/i.test(String(value || "").trim());
}

function getCurrentShopDomain() {
  const fromMegaskaAuth =
    window?.MegaskaAuth &&
    typeof window.MegaskaAuth.getCurrentShopDomain === "function"
      ? normalizeShopDomain(window.MegaskaAuth.getCurrentShopDomain())
      : "";

  if (isMyShopifyDomain(fromMegaskaAuth)) {
    return fromMegaskaAuth;
  }

  const candidates = [
    window?.MEGASKA_SHOP_DOMAIN,
    window?.Shopify?.shop,
    document?.documentElement?.getAttribute?.("data-shop-domain"),
    document?.body?.getAttribute?.("data-shop-domain"),
  ]
    .map(normalizeShopDomain)
    .filter(Boolean);

  for (const candidate of candidates) {
    if (isMyShopifyDomain(candidate)) {
      return candidate;
    }
  }

  return "";
}

  async function getMegaskaSessionToken() {
    try {
      if (window.MegaskaAuth) {
        if (typeof window.MegaskaAuth.getSessionToken === "function") {
          const token = await window.MegaskaAuth.getSessionToken();
          if (token) return String(token).trim();
        }
        if (typeof window.MegaskaAuth.getToken === "function") {
          const token = await window.MegaskaAuth.getToken();
          if (token) return String(token).trim();
        }
      }
    } catch (_error) {}

    try {
      return String(window.localStorage.getItem("megaska_session_token") || "").trim();
    } catch (_error) {
      return "";
    }
  }

  async function megaskaApiFetch(path, options) {
  const normalizedPath = String(path || "").trim().startsWith("/")
    ? String(path || "").trim()
    : `/${String(path || "").trim()}`;

  const token = await getMegaskaSessionToken();
  const shopDomain = getCurrentShopDomain();

  const url = new URL(`${getMegaskaApiBase()}${normalizedPath}`);
  if (shopDomain) {
    url.searchParams.set("shop", shopDomain);
  }

  const baseHeaders = {
    Accept: "application/json",
  };

  if (token) {
    baseHeaders.Authorization = `Bearer ${token}`;
  }

  if (shopDomain) {
    baseHeaders["x-shopify-shop-domain"] = shopDomain;
  }

  const incomingHeaders = options?.headers || {};
  const mergedHeaders = Object.assign({}, baseHeaders, incomingHeaders);

  return fetch(url.toString(), Object.assign({}, options || {}, {
    headers: mergedHeaders,
    credentials: "include",
  }));
}

  function extractCartId(cart) {
    return String(cart?.token || cart?.cart_token || cart?.id || "").trim();
  }

  function setCheckoutResumeFlag() {
    try {
      sessionStorage.setItem(CHECKOUT_RESUME_KEY, "1");
    } catch (_error) {}
  }

  function clearCheckoutResumeFlag() {
    try {
      sessionStorage.removeItem(CHECKOUT_RESUME_KEY);
    } catch (_error) {}
  }

  function hasCheckoutResumeFlag() {
    try {
      return sessionStorage.getItem(CHECKOUT_RESUME_KEY) === "1";
    } catch (_error) {
      return false;
    }
  }

  async function fetchCart() {
    const res = await fetch("/cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    });
    if (!res.ok) throw new Error(`Unable to load cart (${res.status})`);
    return res.json();
  }

  async function changeLineQuantity(lineKey, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: lineKey, quantity }),
    }).then(async (res) => {
      if (!res.ok) throw new Error(`Unable to update quantity (${res.status})`);
      return res.json();
    });
  }

  function removeLine(lineKey) {
    return changeLineQuantity(lineKey, 0);
  }

  async function fetchDashboardSummary() {
    const res = await megaskaApiFetch("/dashboard/summary", {
      method: "GET",
    });
    if (!res.ok) throw new Error(`Dashboard summary unavailable (${res.status})`);
    return res.json();
  }

  function resetWalletStateForLoading() {
    state.customer.sessionActive = false;
    state.customer.profile = null;
    state.customer.dashboard = null;

    state.wallet.visible = true;
    state.wallet.balance = 0;
    state.wallet.currency = "INR";
    state.wallet.pendingRefund = 0;
    state.wallet.status = "loading";
    state.wallet.message = null;
  }

  async function detectCustomerSession() {
    const token = await getMegaskaSessionToken();

    if (!token) {
      state.customer.sessionActive = false;
      state.customer.profile = null;
      state.customer.dashboard = null;
      state.wallet.visible = true;
      state.wallet.status = "login_required";
      state.wallet.message = null;
      state.wallet.balance = 0;
      state.wallet.pendingRefund = 0;
      return;
    }

    state.customer.sessionActive = true;
    state.wallet.visible = true;

    try {
      const summary = await fetchDashboardSummary();
      state.customer.dashboard = summary || null;
      state.customer.profile = summary?.customer || null;

      const wallet = summary?.wallet || {};
      const availableToRedeem = Number(wallet.availableToRedeem || wallet.balance || 0);

      state.wallet.balance = availableToRedeem;
      state.wallet.currency = String(wallet.currency || "INR");
      state.wallet.pendingRefund = Number(wallet.pendingRefund || 0);
      state.wallet.status = "available";
      state.wallet.message = null;
    } catch (_error) {
      state.wallet.status = "unavailable";
      state.wallet.message = "Megaska credit is unavailable right now.";
      state.wallet.balance = 0;
      state.wallet.pendingRefund = 0;
    }
  }

  function lineVariantText(item) {
    return item?.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
  }

  function getComputedTotals() {
  const originalTotalMinor = Number(state.cart?.original_total_price || 0);
  const totalPriceMinor = Number(state.cart?.total_price || 0);
  const totalDiscountMinor = Math.max(originalTotalMinor - totalPriceMinor, 0);

  return {
    subtotalMinor: originalTotalMinor,
    cartDiscountMinor: totalDiscountMinor,
    estimatedTotalMinor: totalPriceMinor,
  };
}

  function normalizeRedirectTarget(rawUrl) {
  const fallback = "/checkout";
  const value = String(rawUrl || "").trim();
  if (!value) return fallback;

  try {
    const url = new URL(value, window.location.origin);

    // Preserve full absolute URL for Shopify-hosted cart/checkout redirects.
    if (url.origin !== window.location.origin) {
      return url.toString();
    }

    return `${url.pathname}${url.search}${url.hash}` || fallback;
  } catch (_error) {
    return value.startsWith("/") ? value : fallback;
  }
}

  function renderLoading() {
    root.innerHTML = '<div id="megaska-bag-loading" class="megaska-bag-loading">Loading your bag...</div>';
  }

  function renderError(message) {
    root.innerHTML = `
      <section class="megaska-bag-card">
        <h2>Unable to load your bag</h2>
        <p class="megaska-bag-muted">${escapeHtml(message || "Please try again.")}</p>
        <button class="megaska-bag-btn megaska-bag-btn--primary" data-bag-action="retry-load" type="button">Retry</button>
      </section>
    `;
  }

  function getSavedBagPin() {
    try {
      return String(localStorage.getItem("megaska_bag_pin") || "").trim();
    } catch (_error) {
      return "";
    }
  }

  function saveBagPin(pin) {
    try {
      localStorage.setItem("megaska_bag_pin", String(pin || "").trim());
    } catch (_error) {}
  }

  function hydrateSavedBagPin() {
    const input = document.getElementById("megaska-bag-pincode-input");
    if (!input) return;

    const savedPin = getSavedBagPin();
    if (savedPin && savedPin.length === 6) {
  setTimeout(() => {
    handlePincodeCheck();
  }, 300);
}
  }

  function renderDeliveryStrip() {
  const savedDelivery = getSavedDeliveryPinResult();

  if (savedDelivery) {
    const deliveryInfo = buildDeliveryMessage(savedDelivery);
    const location = [savedDelivery.city || savedDelivery.inc, savedDelivery.pin]
      .filter(Boolean)
      .join(", ");

    return `
      <div class="megaska-bag-delivery-strip megaska-bag-card">
        <div class="megaska-bag-delivery-card megaska-bag-delivery-card--success">
          <div class="megaska-bag-delivery-card__icon">🚚</div>
          <div class="megaska-bag-delivery-card__content">
            <div class="megaska-bag-delivery-card__eyebrow">
              Delivering to ${escapeHtml(location)}
            </div>
            <div class="megaska-bag-delivery-card__title">
              Estimated delivery: ${escapeHtml(deliveryInfo.deliveryRangeLabel || "")}
            </div>
            <div class="megaska-bag-delivery-card__subtitle">
              ${escapeHtml(deliveryInfo.shipLabel || "")}
            </div>
          </div>
        </div>
      </div>
    `;
  }

  return `
    <div class="megaska-bag-delivery-strip megaska-bag-card">
      <div class="megaska-bag-delivery-strip__head">
        <div>
          <p class="megaska-bag-delivery-strip__eyebrow">Delivery</p>
          <h3 class="megaska-bag-delivery-strip__title">Check delivery & serviceability</h3>
          <p class="megaska-bag-delivery-strip__sub">Enter pincode to check the delivery details</p>
        </div>
      </div>

      <div class="megaska-bag-pincode-form">
        <input
          id="megaska-bag-pincode-input"
          class="megaska-bag-pincode-input"
          type="text"
          inputmode="numeric"
          maxlength="6"
          placeholder="Enter PIN code"
          value=""
          autocomplete="off"
          tabindex="0"
        />
        <button
          type="button"
          class="megaska-bag-btn megaska-bag-btn--primary megaska-bag-pincode-btn"
          data-bag-action="check-pincode"
        >
          Check
        </button>
      </div>

      <div id="megaska-bag-pincode-result" class="megaska-bag-pincode-result-wrap"></div>
    </div>
  `;
}
  function getPincodeApiUrl(pin) {
    return `${MEGASKA_PINCODE_ENDPOINT}?pin=${encodeURIComponent(String(pin || "").trim())}`;
  }

  function formatShortDate(date) {
    try {
      return date.toLocaleDateString("en-IN", {
        day: "numeric",
        month: "short",
      });
    } catch (_error) {
      return "";
    }
  }

  function addDays(date, days) {
    const d = new Date(date);
    d.setDate(d.getDate() + Number(days || 0));
    return d;
  }

  function buildDeliveryMessage(data) {
    const now = new Date();
    const hour = now.getHours();

    const tatDaysRaw = Number(data.tatDays || 0);
    const tatDaysSafe = tatDaysRaw > 0 ? tatDaysRaw + 1 : 3;

    const shipsTomorrow = hour >= 12;
    const dispatchDays = shipsTomorrow ? 1 : 0;

    const startOffset = Math.max(1, dispatchDays + tatDaysSafe - 1);
    const endOffset = Math.max(startOffset, dispatchDays + tatDaysSafe);

    const startDate = addDays(now, startOffset);
    const endDate = addDays(now, endOffset);

    return {
      shipLabel: shipsTomorrow ? "Ships tomorrow" : "Ships today",
      deliveryRangeLabel:
        formatShortDate(startDate) === formatShortDate(endDate)
          ? formatShortDate(startDate)
          : `${formatShortDate(startDate)}–${formatShortDate(endDate)}`,
    };
  }
function getSavedDeliveryPinResult() {
  try {
    const raw = localStorage.getItem("megaska_delivery_pin_result");
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (!parsed || !/^\d{6}$/.test(String(parsed.pin || ""))) return null;

    return parsed;
  } catch (_error) {
    return null;
  }
}
  function renderPincodeResult(data) {
    const target = document.getElementById("megaska-bag-pincode-result");
    if (!target) return;

    if (!data || data.ok !== true) {
      target.innerHTML = `
        <div class="megaska-bag-delivery-card megaska-bag-delivery-card--error">
          <div class="megaska-bag-delivery-card__icon">⚠️</div>
          <div class="megaska-bag-delivery-card__content">
            <div class="megaska-bag-delivery-card__title">Unable to check delivery</div>
            <div class="megaska-bag-delivery-card__subtitle">
              ${escapeHtml(data?.error || "Please try again in a moment.")}
            </div>
          </div>
        </div>
      `;
      return;
    }

    if (!data.isServiceable) {
      target.innerHTML = `
        <div class="megaska-bag-delivery-card megaska-bag-delivery-card--warn">
          <div class="megaska-bag-delivery-card__icon">📍</div>
          <div class="megaska-bag-delivery-card__content">
            <div class="megaska-bag-delivery-card__title">Delivery unavailable</div>
            <div class="megaska-bag-delivery-card__subtitle">
              We currently do not ship to PIN ${escapeHtml(data.pin)}.
            </div>
          </div>
        </div>
      `;
      return;
    }

    const deliveryInfo = buildDeliveryMessage(data);

    target.innerHTML = `
      <div class="megaska-bag-delivery-card megaska-bag-delivery-card--success">
        <div class="megaska-bag-delivery-card__icon">🚚</div>
        <div class="megaska-bag-delivery-card__content">
          <div class="megaska-bag-delivery-card__eyebrow">
            Delivery to ${escapeHtml(data.pin)}
          </div>
          <div class="megaska-bag-delivery-card__title">
            Estimated delivery: ${escapeHtml(deliveryInfo.deliveryRangeLabel || "")}
          </div>
          <div class="megaska-bag-delivery-card__subtitle">
            ${escapeHtml(deliveryInfo.shipLabel || "")}
          </div>
          <div class="megaska-bag-delivery-card__chips">
            <span class="megaska-bag-delivery-chip megaska-bag-delivery-chip--ok">
              Delivery available
            </span>
            <span class="megaska-bag-delivery-chip ${data.isCod ? "megaska-bag-delivery-chip--ok" : "megaska-bag-delivery-chip--muted"}">
              ${data.isCod ? "COD available" : "COD unavailable"}
            </span>
            ${
              data.city || data.stateCode
                ? `<span class="megaska-bag-delivery-chip megaska-bag-delivery-chip--muted">
                    ${escapeHtml([data.city, data.stateCode].filter(Boolean).join(", "))}
                  </span>`
                : ""
            }
          </div>
        </div>
      </div>
    `;

    saveBagPin(data.pin);
  }

function sanitizeDiscountCode(value) {
  return String(value || "")
    .trim()
    .replace(/\s+/g, "")
    .toUpperCase();
}
function getAppliedCartDiscounts() {
  const applications = Array.isArray(state.cart?.cart_level_discount_applications)
    ? state.cart.cart_level_discount_applications
    : [];

  return applications
    .map((item) => String(item?.title || "").trim())
    .filter(Boolean);
}

function hasAppliedCartDiscount() {
  return Number(state.cart?.total_discount || 0) > 0 || getAppliedCartDiscounts().length > 0;
}

async function updateCartDiscountCodes(discountValue) {
  const response = await fetch("/cart/update.js", {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      discount: String(discountValue || ""),
    }),
  });

  if (!response.ok) {
    throw new Error(`Unable to update discount (${response.status})`);
  }

  return response.json();
}
  async function handlePincodeCheck() {
    const input = document.getElementById("megaska-bag-pincode-input");
    const result = document.getElementById("megaska-bag-pincode-result");
    const button = document.querySelector('[data-bag-action="check-pincode"]');
    if (!input || !result || !button) return;

    const pin = String(input.value || "").replace(/\D/g, "").slice(0, 6);
    input.value = pin;

    if (pin.length < 6) {
      renderPincodeResult({
        ok: false,
        error: "Please enter a valid 6-digit PIN code.",
      });
      return;
    }

    button.disabled = true;
    button.textContent = "Checking...";
    result.innerHTML = `
      <div class="megaska-bag-delivery-card">
        <div class="megaska-bag-delivery-card__icon">⏳</div>
        <div class="megaska-bag-delivery-card__content">
          <div class="megaska-bag-delivery-card__title">Checking delivery...</div>
          <div class="megaska-bag-delivery-card__subtitle">Please wait a moment.</div>
        </div>
      </div>
    `;

    try {
      const response = await fetch(getPincodeApiUrl(pin), {
        method: "GET",
        mode: "cors",
        headers: { Accept: "application/json" },
      });

      const text = await response.text();
      let data;

      try {
        data = text ? JSON.parse(text) : { ok: false, error: "Empty server response" };
      } catch (_err) {
        data = { ok: false, error: "Invalid server response" };
      }

      renderPincodeResult(data);

      if (data?.ok) {
        saveBagPin(pin);
      }
    } catch (_error) {
      renderPincodeResult({
        ok: false,
        error: "Unable to check delivery right now.",
      });
    } finally {
       hideCheckoutLoader();
      button.disabled = false;
      button.textContent = "Check";
    }
  }

  function renderItemsSection() {
    const items = Array.isArray(state.cart?.items) ? state.cart.items : [];

    const itemsMarkup = items
      .map((item) => {
        const variant = lineVariantText(item);
        const lineBusy = state.ui.busyLineKey === item.key;

        return `
          <article class="megaska-bag-line" data-line-key="${escapeHtml(item.key)}">
            <img
              class="megaska-bag-line__image"
              src="${escapeHtml(item.image || "")}"
              alt="${escapeHtml(item.product_title)}"
              loading="lazy"
            />
            <div>
              <h3 class="megaska-bag-line__title">${escapeHtml(item.product_title)}</h3>
              ${variant ? `<p class="megaska-bag-line__variant">${escapeHtml(variant)}</p>` : ""}
              <p class="megaska-bag-line__unit">Unit: ${formatMoneyFromMinor(item.price, state.cart.currency)}</p>
              <div class="megaska-bag-line__meta">
                <div class="megaska-bag-qty">
                  <button
                    class="megaska-bag-btn megaska-bag-btn--tiny"
                    type="button"
                    data-bag-action="decrease-qty"
                    ${lineBusy ? "disabled" : ""}
                  >−</button>
                  <span>${Number(item.quantity || 0)}</span>
                  <button
                    class="megaska-bag-btn megaska-bag-btn--tiny"
                    type="button"
                    data-bag-action="increase-qty"
                    ${lineBusy ? "disabled" : ""}
                  >+</button>
                </div>
                <strong>${formatMoneyFromMinor(item.final_line_price || item.line_price, state.cart.currency)}</strong>
              </div>
              <button
                class="megaska-bag-btn megaska-bag-btn--link"
                type="button"
                data-bag-action="remove-line"
                ${lineBusy ? "disabled" : ""}
              >Remove</button>
            </div>
          </article>
        `;
      })
      .join("");

    return `
      <section id="bag-items-section" class="megaska-bag-card">
        ${renderDeliveryStrip()}
        <div style="display:flex;justify-content:space-between;gap:8px;align-items:center;">
          <h2 style="margin:0;">Items (${items.length})</h2>
          <div style="display:flex;gap:8px;align-items:center;">
            <button class="megaska-bag-btn" type="button" data-bag-action="continue-shopping">Continue Shopping</button>
            <button class="megaska-bag-btn" type="button" data-bag-action="refresh-bag">Refresh</button>
          </div>
        </div>
        <div class="megaska-bag-line-list" style="margin-top:12px;">
          ${itemsMarkup}
        </div>
      </section>

      <section class="megaska-bag-reco-placeholder" hidden aria-hidden="true"></section>
    `;
  }

  function renderWalletSection() {
    let body = "";

    if (state.wallet.status === "loading") {
      body = `
        <div class="megaska-bag-wallet__placeholder">
          <p class="megaska-bag-muted">Loading Megaska credit...</p>
        </div>
      `;
    } else if (!state.customer.sessionActive || state.wallet.status === "login_required") {
      body = `
        <p class="megaska-bag-muted">Login to view your Megaska credit balance.</p>
        <button class="megaska-bag-btn" data-bag-action="wallet-login" type="button">
          Login to View Balance
        </button>
      `;
    } else {
      body = `
        <div class="megaska-bag-wallet__balance-wrap">
          <p class="megaska-bag-wallet__label">Megaska Credit Balance</p>
          <div class="megaska-bag-wallet__balance">
            ${formatMoneyFromMinor(state.wallet.balance, state.wallet.currency)}
          </div>
        </div>

        ${
          state.wallet.pendingRefund > 0
            ? `
            <div class="megaska-bag-row">
              <span>Pending refund</span>
              <strong>${formatMoneyFromMinor(state.wallet.pendingRefund, state.wallet.currency)}</strong>
            </div>
          `
            : ""
        }

        <p class="megaska-bag-wallet__helper">
          COD refunds are credited here as per Megaska policy.
        </p>

        <p class="megaska-bag-note">
          Redemption is handled separately through support-issued discount codes.
        </p>
      `;
    }

    return `
      <section id="bag-wallet-section" class="megaska-bag-card megaska-bag-wallet-card">
        <div class="megaska-bag-wallet-card__head">
          <h2 style="margin:0;">Megaska Credit</h2>
        </div>
        ${body}
        ${state.wallet.message ? `<p class="megaska-bag-error">${escapeHtml(state.wallet.message)}</p>` : ""}
      </section>
    `;
  }

  function renderSummarySection() {
    const appliedDiscounts = getAppliedCartDiscounts();
const hasCartDiscount = hasAppliedCartDiscount();
  const totals = getComputedTotals();

  const mrp = Number(totals.subtotalMinor || 0);
  const discount = Number(totals.cartDiscountMinor || 0);
  const total = Number(totals.estimatedTotalMinor || 0);

  const totalSavings = discount;
  const discountPercent = mrp > 0 ? Math.round((discount / mrp) * 100) : 0;
  const checkoutLabel = state.ui.checkoutBusy ? "Preparing..." : "PLACE ORDER";

  return `
    <section id="bag-summary-section" class="megaska-bag-card"> 
      <h2 class="megaska-bag-summary__title">Price Details</h2>

      <div class="megaska-bag-row">
        <span>Sub Total</span>
        <strong>${formatMoneyFromMinor(mrp, state.cart.currency)}</strong>
      </div>

      ${
        discount > 0
          ? `
      <div class="megaska-bag-row">
        <span>Discount (${discountPercent}%)</span>
        <strong class="megaska-bag-negative">
          − ${formatMoneyFromMinor(discount, state.cart.currency)}
        </strong>
      </div>
      `
          : ""
      }

      <div class="megaska-bag-row">
        <span>Shipping</span>
        <strong class="megaska-bag-positive">FREE</strong>
      </div>

      <div class="megaska-bag-row">
        <span>Taxes</span>
        <strong>Included</strong>
      </div>

      <div class="megaska-bag-divider"></div>

      <div class="megaska-bag-row megaska-bag-row--total">
        <span>You Pay :</span>
        <strong>${formatMoneyFromMinor(total, state.cart.currency)}</strong>
      </div>

      ${
        totalSavings > 0
          ? `
      <div class="megaska-bag-summary__savings">
        You Saved : ${formatMoneyFromMinor(totalSavings, state.cart.currency)}
      </div>
      `
          : ""
      }
<div class="megaska-bag-discount-box">
  <p class="megaska-bag-discount-box__title">Discount code</p>

  ${
    hasCartDiscount
      ? `
    <div class="megaska-bag-discount-box__applied">
      <span class="megaska-bag-discount-box__badge">
        ${escapeHtml(appliedDiscounts.join(", ") || "Discount applied")}
      </span>
      <button
        class="megaska-bag-btn megaska-bag-btn--link"
        type="button"
        data-bag-action="remove-discount"
      >
        Remove
      </button>
    </div>
    <p class="megaska-bag-note">
      A discount is already applied. Additional codes will work only subject to allowed combination.
    </p>
  `
      : `
    <p class="megaska-bag-note">Enter a discount code.</p>
  `
  }

  <div class="megaska-bag-discount-box__form">
    <input
      id="megaska-bag-discount-input"
      class="megaska-bag-discount-box__input"
      type="text"
      inputmode="text"
      maxlength="64"
      placeholder="Enter discount code"
      autocomplete="off"
    />
    <button
      class="megaska-bag-btn"
      type="button"
      data-bag-action="apply-discount"
    >
      Apply
    </button>
  </div>
</div>      <button
        class="megaska-bag-btn megaska-bag-btn--primary"
        data-bag-action="checkout"
        type="button"
        style="width:100%;margin-top:12px;"
        ${state.ui.checkoutBusy ? "disabled" : ""}
      >
        ${checkoutLabel}
      </button>

      <p class="megaska-bag-summary__secure">
        🔒 Secure checkout via Razorpay/UPI/COD
      </p>
    </section>
  `;
}
  function renderTrustSection() {
    return `
      <section id="bag-trust-section" class="megaska-bag-card">
        <h3 style="margin:0;">Why checkout with confidence</h3>
        <ul class="megaska-bag-trust-list">
          <li>Secure payment and order processing through Shopify checkout.</li>
          <li>Support for eligible exchanges through your Megaska dashboard.</li>
          <li>Built for a better coverage and comfort shopping experience.</li>
        </ul>
      </section>
    `;
  }
async function applyDiscountCodeFromInput() {
  const input = document.getElementById("megaska-bag-discount-input");
  if (!input) return;

  const code = sanitizeDiscountCode(input.value);
  if (!code) {
    state.ui.errorMessage = "Please enter a valid discount code.";
    render();
    return;
  }

  try {
    await updateCartDiscountCodes(code);
    await reloadCartView();
    state.ui.errorMessage = null;
    render();
  } catch (error) {
    state.ui.errorMessage =
      error instanceof Error ? error.message : "Unable to apply discount code.";
    render();
  }
}
function notifyHeaderCartCount(itemCount) {
  document.dispatchEvent(
    new CustomEvent('megaska:cart-updated', {
      detail: { item_count: Number(itemCount) || 0 }
    })
  );
}
async function removeDiscountCode() {
  try {
    await updateCartDiscountCodes("");
    await reloadCartView();
    state.ui.errorMessage = null;
    render();
  } catch (error) {
    state.ui.errorMessage =
      error instanceof Error ? error.message : "Unable to remove discount code.";
    render();
  }
}
function renderStickyFooter() {
  const totals = getComputedTotals();
  const checkoutLabel = state.ui.checkoutBusy ? "Preparing..." : "PLACE ORDER";

  return `
    <section id="bag-sticky-footer">
      <div class="megaska-bag-sticky__inner">
        
        <div class="megaska-bag-sticky__meta">
          <p class="megaska-bag-sticky__label">You Pay :</p>
          <p class="megaska-bag-sticky__amount">
            ${formatMoneyFromMinor(totals.estimatedTotalMinor, state.cart.currency)}
          </p>
        </div>

        <div class="megaska-bag-sticky__cta">
          <button
            class="megaska-bag-btn megaska-bag-btn--primary"
            data-bag-action="checkout"
            type="button"
            ${state.ui.checkoutBusy ? "disabled" : ""}
          >
            ${checkoutLabel}
          </button>
        </div>

      </div>
    </section>
  `;
}
function renderBagLayout() {
  root.innerHTML = `
    <div class="megaska-bag-layout">
      <div class="megaska-bag-main">
        ${renderItemsSection()}
        ${renderUpsellSection()}
      </div>
      <aside class="megaska-bag-sidebar">
        ${renderSummarySection()}
      </aside>
    </div>

    <section class="megaska-bag-bottom-info-wrap">
      ${renderBagInfoSection()}
    </section>

    ${renderStickyFooter()}
  `;
}
  function renderEmptyState() {
    root.innerHTML = `
      <section class="megaska-bag-card megaska-bag-empty">
        <h2>Your beach bag is waiting.</h2>
        <p class="megaska-bag-muted">Time to find your perfect swim.</p>
        <button class="megaska-bag-btn megaska-bag-btn--primary" data-bag-action="continue-shopping" type="button">Continue Shopping</button>
      </section>
    `;
  }

  function render() {
    if (state.pageStatus === "loading") return renderLoading();
    if (state.pageStatus === "error") return renderError(state.ui.errorMessage || "Please try again.");
    if (state.pageStatus === "empty") return renderEmptyState();
    return renderBagLayout();
  }

  function openOtpForBagCheckout() {
    setCheckoutResumeFlag();

    if (window.MegaskaAuth && typeof window.MegaskaAuth.openOtpModal === "function") {
      window.MegaskaAuth.openOtpModal({ returnTo: "/pages/bag" });
      return true;
    }

    if (window.MegaskaAuth && typeof window.MegaskaAuth.openAuthModal === "function") {
      window.MegaskaAuth.openAuthModal({ returnTo: "/pages/bag" });
      return true;
    }

    if (window.MegaskaOtp && typeof window.MegaskaOtp.openModal === "function") {
      window.MegaskaOtp.openModal("checkout");
      return true;
    }

    console.warn("[Megaska Bag] OTP modal bridge unavailable for checkout");
    return false;
  }

  function triggerWalletLoginFlow() {
    if (window.MegaskaAuth && typeof window.MegaskaAuth.openOtpModal === "function") {
      window.MegaskaAuth.openOtpModal({ returnTo: "/pages/bag" });
      return;
    }

    if (window.MegaskaOtp && typeof window.MegaskaOtp.openModal === "function") {
      window.MegaskaOtp.openModal("wallet-login");
      return;
    }

    if (window.MegaskaAuth && typeof window.MegaskaAuth.openAuthModal === "function") {
      window.MegaskaAuth.openAuthModal({ returnTo: "/pages/bag" });
      return;
    }

    console.warn("[Megaska Bag] OTP modal bridge unavailable for wallet login");
  }

  async function reloadCartView() {
    const cart = await fetchCart();
    state.cart = cart;
    state.pageStatus = Array.isArray(cart?.items) && cart.items.length ? "ready" : "empty";
  }

  async function resolveMegaskaCustomer(preferredCustomer) {
    if (preferredCustomer && typeof preferredCustomer === "object") {
      return preferredCustomer;
    }

    try {
      if (state.customer.profile) return state.customer.profile;

      if (window.MegaskaAuth && typeof window.MegaskaAuth.fetchSession === "function") {
        const session = await window.MegaskaAuth.fetchSession();
        return session?.customer || null;
      }
    } catch (error) {
      console.warn("[Megaska Bag] unable to resolve Megaska customer", error);
    }

    return null;
  }

  async function buildPrefilledCheckoutUrl(rawUrl, preferredCustomer) {
    if (!rawUrl || !String(rawUrl).includes("/checkout")) return rawUrl;

    const customer = await resolveMegaskaCustomer(preferredCustomer);
    if (!customer) return rawUrl;

    if (
      window.MegaskaAuth &&
      typeof window.MegaskaAuth.applyCheckoutPrefillToUrl === "function"
    ) {
      const prefilledUrl = window.MegaskaAuth.applyCheckoutPrefillToUrl(rawUrl, customer);
      return prefilledUrl || rawUrl;
    }

    return rawUrl;
  }

  function mergeCheckoutQueryParams(baseUrl, prefilledUrl) {
    const fallback = prefilledUrl || baseUrl || "";
    if (!baseUrl || !prefilledUrl || !String(prefilledUrl).includes("?")) return fallback;

    try {
      const base = new URL(baseUrl, window.location.origin);
      const prefilled = new URL(prefilledUrl, window.location.origin);

      prefilled.searchParams.forEach((value, key) => {
        if (!base.searchParams.get(key)) {
          base.searchParams.set(key, value);
        }
      });

      return `${base.pathname}${base.search}${base.hash}`;
    } catch (_error) {
      return fallback;
    }
  }

  async function runBuyerIdentityHandoff(rawCheckoutUrl, preferredCustomer) {
    const customer = await resolveMegaskaCustomer(preferredCustomer);

    if (!customer) {
      return {
        ok: false,
        skipped: true,
        reason: "missing-customer",
        checkoutUrl: rawCheckoutUrl,
      };
    }

    if (
      !window.MegaskaAuth ||
      typeof window.MegaskaAuth.applyBuyerIdentityToActiveCart !== "function"
    ) {
      return {
        ok: false,
        skipped: true,
        reason: "missing-auth-bridge",
        checkoutUrl: rawCheckoutUrl,
      };
    }

    try {
      const result = await window.MegaskaAuth.applyBuyerIdentityToActiveCart(customer, {
        checkoutUrl: rawCheckoutUrl,
      });

      const mergedCheckoutUrl = mergeCheckoutQueryParams(
        result?.checkoutUrl || rawCheckoutUrl,
        rawCheckoutUrl
      );

      return Object.assign({}, result || {}, {
        checkoutUrl: mergedCheckoutUrl,
      });
    } catch (error) {
      console.error("[Megaska Bag] buyer identity handoff failed", error);
      return {
        ok: false,
        skipped: false,
        reason: "request-failed",
        checkoutUrl: rawCheckoutUrl,
      };
    }
  }

  function isCheckoutContinuationBlocked(handoff) {
    if (!handoff) return false;
    return (
      handoff.blocked ||
      handoff.reason === "missing-verified-phone" ||
      handoff.reason === "missing-customer"
    );
  }
function hideCheckoutLoader() {
  const loader = document.getElementById("megaska-checkout-loader");
  if (loader) {
    loader.remove();
  }
}
 async function continueToCheckout() {
  if (state.ui.checkoutBusy) return;

  state.ui.checkoutBusy = true;
  render();

  try {
    const token = await getMegaskaSessionToken();
    const customer = state.customer.profile || await resolveMegaskaCustomer();

    if (!token || !customer) {
      state.ui.checkoutBusy = false;
      render();
      openOtpForBagCheckout();
      return;
    }

   showCheckoutLoader();
clearCheckoutResumeFlag();

const expressCheckout =
  window.MegaskaExpressCheckout || window.MegaskaExpressModal;

if (expressCheckout && typeof expressCheckout.open === "function") {
  hideCheckoutLoader();
  await expressCheckout.open({ source: "bag" });
  return;
}

console.warn("[Megaska Bag] Express Checkout modal bridge unavailable");
window.location.assign("/apps/megaska/checkout");
  }
   catch (error) {
    hideCheckoutLoader();
    console.error("[Megaska Bag] express checkout handoff failed", error);
    state.ui.errorMessage =
      error instanceof Error ? error.message : "Unable to continue to checkout.";
      alert(state.ui.errorMessage);
    state.pageStatus = state.cart?.items?.length ? "ready" : "error";
  } finally {
    state.ui.checkoutBusy = false;
    render();
  }
}

async function createExpressCheckoutIntent() {
  const totals = getComputedTotals();
  const cart = state.cart || {};
  const items = Array.isArray(cart.items) ? cart.items : [];

  const cartSnapshot = {
    token: cart.token || cart.cart_token || cart.id || "",
    item_count: cart.item_count || items.length,
    items: items.map(function (item) {
      return {
        variantId: item.variant_id,
        shopifyVariantId: item.variant_id,
        quantity: item.quantity,
        title: item.product_title || item.title,
        variantTitle: item.variant_title,
        sku: item.sku,
        pricePaise: item.price,
        linePricePaise: item.final_line_price || item.line_price,
      };
    }),
  };

  const response = await megaskaApiFetch("/express/checkout/intents", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      cartToken: extractCartId(cart),
      shopifyCartId: extractCartId(cart),
      cartSnapshot,
      subtotalAmountPaise: totals.subtotalMinor,
      discountAmountPaise: totals.cartDiscountMinor,
      shippingAmountPaise: 0,
      codFeeAmountPaise: 0,
      totalAmountPaise: totals.estimatedTotalMinor,
      currency: "INR",
    }),
  });

  const data = await response.json().catch(function () {
    return null;
  });

  if (!response.ok || !data || !data.ok || !data.intent || !data.intent.id) {
    throw new Error((data && data.error) || "Unable to start Express Checkout.");
  }

  return data.intent;
}
function showCheckoutLoader() {
  if (document.getElementById("megaska-checkout-loader")) return;

  const loader = document.createElement("div");
  loader.id = "megaska-checkout-loader";

  loader.innerHTML = `
    <div class="megaska-loader-box">
      <div class="megaska-spinner"></div>
      <p class="megaska-loader-text">Preparing your order...</p>
      <p class="megaska-loader-sub">Redirecting to secure checkout</p>
    </div>
  `;

  document.body.appendChild(loader);
}
  async function resumeCheckoutIfNeeded() {
    if (!hasCheckoutResumeFlag()) return;

    const token = await getMegaskaSessionToken();
    const customer = await resolveMegaskaCustomer();

    if (!token || !customer) return;

    clearCheckoutResumeFlag();

    setTimeout(() => {
      continueToCheckout();
    }, 250);
  }

  async function handleLineMutation(lineKey, nextQty, action) {
  if (!lineKey || state.ui.busyLineKey) return;

  state.ui.busyLineKey = lineKey;
  state.ui.busyAction = action;
  render();

  try {
    if (action === "remove") {
      await removeLine(lineKey);
    } else {
      await changeLineQuantity(lineKey, nextQty);
    }

    await reloadCartView();
    notifyHeaderCartCount(state.cart && state.cart.item_count);
    render();
  } catch (error) {
    state.ui.errorMessage = error instanceof Error ? error.message : "Unable to update bag item.";
    render();
  } finally {
    state.ui.busyLineKey = null;
    state.ui.busyAction = null;
    render();
  }
}

  async function handleAction(action, trigger) {
    if (!action) return;

    if (action === "retry-load") {
      await init();
      return;
    }
if (action === "apply-discount") {
  applyDiscountCodeFromInput();
  return;
}

if (action === "remove-discount") {
  removeDiscountCode();
  return;
}
    if (action === "check-pincode") {
      await handlePincodeCheck();
      return;
    }

    if (action === "continue-shopping") {
      window.location.assign("/collections/all");
      return;
    }

    if (action === "refresh-bag") {
      try {
        await Promise.all([reloadCartView(), detectCustomerSession()]);
        render();
        hydrateSavedBagPin();
      } catch (error) {
        state.pageStatus = "error";
        state.ui.errorMessage = error instanceof Error ? error.message : "Unable to refresh bag.";
        render();
      }
      return;
    }

    if (action === "checkout") {
      await continueToCheckout();
      return;
    }
    if (action === "add-upsell") {
      try {
        await addUpsellVariantToCart();
        await reloadCartView();
        notifyHeaderCartCount(state.cart && state.cart.item_count);
        state.ui.errorMessage = null;
        render();
      } catch (error) {
        state.ui.errorMessage =
          error instanceof Error ? error.message : "Unable to add offer.";
        render();
      }
      return;
    }
    if (action === "wallet-login") {
      triggerWalletLoginFlow();
      return;
    }

    const lineNode = trigger && trigger.closest ? trigger.closest("[data-line-key]") : null;
    const lineKey = lineNode ? String(lineNode.getAttribute("data-line-key") || "").trim() : "";
    const item = (state.cart?.items || []).find((entry) => String(entry.key) === lineKey);
    if (!item) return;

    if (action === "decrease-qty") {
      const nextQty = Math.max(Number(item.quantity || 0) - 1, 0);
      await handleLineMutation(lineKey, nextQty, nextQty <= 0 ? "remove" : "decrease");
      return;
    }

    if (action === "increase-qty") {
      await handleLineMutation(lineKey, Number(item.quantity || 0) + 1, "increase");
      return;
    }

    if (action === "remove-line") {
      await handleLineMutation(lineKey, 0, "remove");
    }
  }
function renderBagInfoSection() {
  return `
    <section id="bag-info-section" class="megaska-bag-card megaska-bag-info-card">
      <h3 class="megaska-bag-info-card__title">Why shop with Megaska?</h3>

      <ul class="megaska-bag-info-card__list">
        <li>Tax included in all prices — no hidden charges.</li>
        <li>Free shipping across India on every order.</li>
        <li>Easy size exchange for size issues as per our policy.</li>
      </ul>

      <div class="megaska-bag-info-card__delivery">
        <strong>Shipping & delivery:</strong>
        <p>Orders placed before <strong>12:00 noon</strong> are usually shipped the same day (Mon–Sat).</p>
        <p>Orders after 12:00 noon, Sundays and public holidays are shipped on the next working day.</p>
        <p>Typical delivery time is <strong>3–4 working days</strong> for most pincodes in India.</p>
      </div>

      <p class="megaska-bag-info-card__help">
        Need help with your order or size?
        <a href="https://wa.me/919650957372" target="_blank" rel="noopener noreferrer">Chat with us on WhatsApp: 9650957372</a>
      </p>
    </section>
  `;
}
  function bindAuthStateRefresh() {
  document.addEventListener("megaska:auth-state-changed", async function () {
    try {
      await detectCustomerSession();
      render();
      await resumeCheckoutIfNeeded();
    } catch (error) {
      console.warn("[Megaska Bag] auth-state refresh failed", error);
    }
  });
}

  root.addEventListener("click", function (event) {
    const target = event.target instanceof Element ? event.target.closest("[data-bag-action]") : null;
    if (!target) return;

    const action = String(target.getAttribute("data-bag-action") || "").trim();
    if (!action) return;

    event.preventDefault();
    handleAction(action, target);
  });
function removeInitialPincodeFocus() {
  setTimeout(function () {
    const input = document.getElementById("megaska-bag-pincode-input");
    if (input) input.blur();
  }, 100);
}
  async function init() {
    hideCheckoutLoader();
  state.pageStatus = "loading";
  state.ui.errorMessage = null;
  state.ui.checkoutBusy = false;
  resetWalletStateForLoading();
  render();

  try {
    // Step 1: load cart first and render immediately
    await reloadCartView();
    render();
   

    removeInitialPincodeFocus();

    // Step 2: load customer/session info in background
    detectCustomerSession()
      .then(() => {
        render();
        return resumeCheckoutIfNeeded();
      })
      .catch((error) => {
        console.warn("[Megaska Bag] background session load failed", error);
        render();
      });
  } catch (error) {
    state.pageStatus = "error";
    state.ui.errorMessage = error instanceof Error ? error.message : "Unable to load bag.";
    render();
  }
}

  bindAuthStateRefresh();
  window.addEventListener("pageshow", function () {
  hideCheckoutLoader();
});
  init();
  
})();